import { AgmMap } from '@agm/core';
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../config/config';
import {
  VisitorCalendarActionCommand,
  VisitorSettingsCommand,
  VisitorTripIdCommand,
} from '../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand, HubVisitorRegion } from '../../../commands/visitor/all.frontend.settings.command';
import { CreateTripCommand, TripStorageCommand } from '../../../commands/visitor/create.trip.command';
import { BaseComponent } from '../../../common/components/base.component';
import { FieldComponent } from '../../../common/components/field/field.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { SearchComponent } from '../../../common/components/search/search.component';
import { SelectComponent } from '../../../common/components/select/select.component';
import { SocialLoginPopupComponent } from '../../../common/components/social.login.popup/social.login.popup.component';
import { WaterFallContainerComponent } from '../../../common/components/water.fall.container/water.fall.container.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { bindFunctionsToThis, clone, isNullOrUndefined } from '../../../common/extensions';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { ModalService } from '../../../common/services/modal.service';
import { EditorChoiceDataSource, HubEvent } from '../../../models/hub/hub.event';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubTour } from '../../../models/hub/hub.tour';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { ImageService } from '../../../services/image.service';
import { LocalStorageService } from '../../../services/localStorageService';
import { VisitorApiService } from '../../../services/visitor.api.service';
import {
  AllFrontendSettingsStore,
  VisitorCalendarStore,
  VisitorDataCache,
  VisitorTripIdStore,
  VisitorTripStore,
} from '../../../stores/visitor.calendar.store';
import { guid } from '../../../utils/guid';
import { DirectionPlanComponent } from '../../hub/tours/direction.plan/direction.plan.component';
import { BlockNavigatorComponent } from './block.navigator/block.navigator.component';
import { TripMapBottomInfoComponent } from './trip.map.bottom.info/trip.map.bottom.info.component';
import { VisitorTripSideBarComponent } from './trip.side.bar/visitor.trip.side.bar.component';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/delay';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { StyleModel } from '../../../commands/hub/style.command';
import { Location } from '@angular/common';
import { EditorChoiceStore } from '../../../stores/hub.calendar.store';

@Component({
  selector: 'ig-trip-planner',
  templateUrl: './visitor.trip.component.html',
  styleUrls: [
    './visitor.trip.component.scss',
    '../../../../node_modules/snazzy-info-window/dist/snazzy-info-window.css',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorTripComponent extends BaseComponent implements AfterViewInit, OnInit, AfterViewChecked {
  public hubName: string;
  public urlTripID: string;
  public urlTourID: string;
  public urlTripFromUserID: string;
  public isStarted = false;
  public isForExportPDF = false;
  public isPrintVersion = false;
  public isForTourList = false;
  public isForSingleTour = false;
  public searchText: string;
  public searchCityText: string;
  public searchTimeout: any;
  public isSearchDisabled = false;
  public from: Date;
  public to: Date;
  public today = new Date();
  public searchFormGroup = this.formBuilder.group({
    search: [null],
    searchCity: [null],
  });
  public items: HubEvent[] | HubPlace[];
  public tours: HubTour[];
  public isPlanStarted = false;
  public actionCommand: VisitorCalendarActionCommand;
  public isAllDataLoaded: boolean;
  public isLoading: boolean;
  public loadingTip = 'Loading...';
  public FBAuthResponse: any;
  public isLoggedIn = false;
  public isShowDirectionMap = false;
  public isShowNormalMap = false;
  public mapBottomInfoItem: any;
  public mapBottomInfoIndex = -1;
  public isNormalMapReady = false;
  public isShowTour = false;
  public isNoContent = false;
  public isShowWelcomepageNoEventTip = false;
  public isShowSidebarOnMobile = false;
  public isShowFloatDetail = false;
  public isShowfloatDetailPlaceFeeds = false;
  public welcomeImg = config.tripPlannerWelcomeImg;
  public tripTour = new HubTour();
  public isInfoWindowsOpen = [];
  public latLngBounds: any;
  public arrowImg = config.arrow;
  public detailSelectedMapMarker = config.detailSelectedMapMarker;
  public hideIconMapStyler = config.google.hideMapBusinessIconStyles;
  public placeMapIcon = {
    Accommodations: config.tripPlanner.placeMapIcon.accommodation,
    'Arts & Culture': config.tripPlanner.placeMapIcon.arts,
    'Dining & Nightlife': config.tripPlanner.placeMapIcon.dinging,
    Activities: config.tripPlanner.placeMapIcon.activity,
    Shopping: config.tripPlanner.placeMapIcon.shopping,
    'Outdoors & Fitness': config.tripPlanner.placeMapIcon.outdoor,
    Entertainment: config.tripPlanner.placeMapIcon.entertainment,
    Transportation: config.tripPlanner.placeMapIcon.transportation,
    Other: config.tripPlanner.placeMapIcon.other,
    Event: config.tripPlanner.eventMapIcon,
  };
  public lat = 0;
  public lng = 0;
  public tpHomeImageUrl = '';
  public featuresToggle = new HubVisitorFeatureToggle();
  public regionSource: any[];
  public loadingRegion = false;
  public isShowGDPR = false;
  public isMultiCityBlock = true;
  public allRegions = [];
  public allRegionsInOne = new HubVisitorRegion();
  public currentRegion: HubVisitorRegion;
  public regionId: string;
  public noCities = false;
  public profileImage = '';
  public allFrontendSettings = new AllFrontendSettingsCommand();
  public style = new StyleModel();
  @ViewChild('waterFallContainer') public waterFallContainer: WaterFallContainerComponent;
  @ViewChild('spinner') public spinner: PageSpinnerComponent;
  @ViewChild('pagespinner') public pageSpinner: PageSpinnerComponent;
  @ViewChild('direction') public direction: DirectionPlanComponent;
  @ViewChild('sidebar') public sidebar: VisitorTripSideBarComponent;
  @ViewChild('bg') public bg: ElementRef;
  @ViewChild('div') public popup: ElementRef;
  @ViewChild('trip') public tripWrap: ElementRef;
  @ViewChild('searchNotLoggedIn') public searchNotLoggedIn: ElementRef;
  @ViewChild('searchLogginIn') public searchLogginIn: ElementRef;
  @ViewChild('loginIcon') public loginIcon: ElementRef;
  @ViewChild('loginBtnNotLoggedIn') public loginBtnNotLoggedIn: ElementRef;
  @ViewChild('loginBtnLoggedIn') public loginBtnLoggedIn: ElementRef;
  @ViewChild('profile') public profile: ElementRef;
  @ViewChild('loginTip') public loginTip: ElementRef;
  @ViewChild('mobilesearch') public mobilesearch: SearchComponent;
  @ViewChild('map') public map: AgmMap;
  @ViewChild('mapBottomInfo') public mapBottomInfo: TripMapBottomInfoComponent;
  @ViewChild('searchItem') public searchOnDesktop: FieldComponent;
  @ViewChild('blockNavigator') public blockNavigator: BlockNavigatorComponent;
  @ViewChild('regionSelect') public regionSelect: SelectComponent;
  @ViewChild('citySearch') public citySearch: SearchComponent;
  @ViewChild('socialLogin') public socialLogin: SocialLoginPopupComponent;
  @ViewChild('loginBtnWrap') public loginBtnWrap: ElementRef;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private visitorCalendarStore: VisitorCalendarStore,
    private imageService: ImageService,
    private googleMapService: GoogleMapsService,
    private visitorTripStore: VisitorTripStore,
    private visitorTripIdStore: VisitorTripIdStore,
    private visitorApiService: VisitorApiService,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    private customizationApiService: CustomizationApiService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private location: Location,
    private editorChoiceStore: EditorChoiceStore,
    private modalService: ModalService
  ) {
    super({ activatedRoute });
    bindFunctionsToThis(this);
  }

  public ngOnInit() {
    this.pageSpinner.show();
    this.welcomeImg = this.imageService.imageSourceUrl(this.welcomeImg);

    this.checkGDPR();
  }

  public ngAfterViewInit() {
    let { hubName, tripId, tourId, singleTripId, pdf, version, tourOrTrip, tourOrTripId, regionId } =
      this.allRouteParams;
    this.hubName = hubName;
    this.regionId = regionId;
    this.detailSelectedMapMarker = this.imageService.imageSourceUrl(this.detailSelectedMapMarker);

    this.loadSettings(regionId);

    this.urlTripID = tripId;

    // this is for exporting PDF from mobile in side the iFrame.
    // Because iOS shows PDF from this scenario as an image and only shows the first page
    // So when exporting PDF from mobile in side the iFrame,
    // we give the user a link which could redirect to ImGoing directly and start exporting the PDF automatically
    this.forPDFDownload(pdf, version, tourOrTrip, tourOrTripId);

    // show single tour view
    this.forSingleTourView(tripId, singleTripId);

    // show itinerary list view
    this.forItineraryListView(tripId);

    // show user shared trip view
    // tripId: the whole trip ID, singleTripId: one single day trip ID of a whole trip
    this.forUserSharedTrip(tripId, singleTripId);

    this.getEditorChoiceText();
  }

  @HostListener('window:popstate', ['$event'])
  public hashChanged($event) {
    if (this.isScriptSolution) {
      const url = this.router.url;
      console.log('back btn in trip', this.router.url);
      // some sites may redirect to auth page, e.g., https://take321.com/
      this.location.go(this.location.path().replace('/auth', '/'));

      setTimeout(() => {
        this.router.navigateByUrl(url, { skipLocationChange: this.noChangeUrlWhenRedirect });
      }, 100);
    }
  }

  public getEditorChoiceText() {
    this.customizationApiService.getEditorChoice(this.hubName).subscribe((editorChoice: EditorChoiceDataSource) => {
      if (!editorChoice) return;
      editorChoice.editorChoiceForEvent = editorChoice.editorChoiceForEvent || "EDITOR'S CHOICE";
      editorChoice.editorChoiceForPlace = editorChoice.editorChoiceForPlace || "EDITOR'S CHOICE";
      this.editorChoiceStore.infoCommand.next(editorChoice);
    });
  }

  private loadSettings(regionId) {
    /**
     * CalhounAL has a strange issue -- refresh the trip planner page from its inside button could cause trip planner continues showing loading icon, which is a 504 error when loading the settings,
     * so here temporarily load it from local storage
     * TODO check more on this issue
     * https://trello.com/c/yebQz3He/835-bug-event-and-trip-planner-widget-not-loading-after-nav-away-from-page
     * */
    const settingsStr = localStorage.getItem(localStorageKeys.allFrontendSettingsForTP);
    if (this.hubName === 'CalhounAL' && settingsStr) {
      const settings = JSON.parse(settingsStr);
      console.log('load settings from local storage', settings);
      setTimeout(() => {
        this.processSettings(settings, regionId);
      });

      setTimeout(() => {
        this.customizationApiService.getAllFrontendSettingsForTP(this.hubName, regionId).subscribe((allSettings) => {
          localStorage.setItem(localStorageKeys.allFrontendSettingsForTP, JSON.stringify(allSettings));
          console.log('settings refreshed');
        });
      }, 1000);
    } else {
      this.customizationApiService
        .getAllFrontendSettingsForTP(this.hubName, regionId)
        .retryWhen((errors) => errors.delay(1000).take(3))
        .catch((err) => {
          throw 'getAllFrontendSettingsForTP: ' + err;
        })
        .subscribe((allSettings) => {
          if (!allSettings) {
            alert(`Account ${this.hubName} not found, please verify!`);
          }
          localStorage.setItem(localStorageKeys.allFrontendSettingsForTP, JSON.stringify(allSettings));
          localStorage.setItem(localStorageKeys.timezoneFormatterDefault, allSettings.timezoneFormatter);
          this.processSettings(allSettings, regionId);
        });
    }
  }

  private forUserSharedTrip(tripId, singleTripId) {
    if (tripId && ['trip', 'tour', 'tour-list'].indexOf(tripId) < 0) {
      this.getTripsFromDBByTripID(this.urlTripID).subscribe((trip) => {
        if (trip) {
          this.urlTripFromUserID = trip.userFacebookId;
          if (singleTripId) {
            trip.trips = trip.trips.filter((x) => x.id === singleTripId);
          }
          this.setLocalStorageForSharedTrip(trip, trip.userFacebookId, true);
        } else {
          window.location.href = config.serverDomain + 'assets/pages/404.html';
        }
      });
    }
  }

  private forItineraryListView(tripId) {
    if (tripId === 'tour-list') {
      this.isForTourList = true; // hide other irrelevant elements
      if (this.isMobile) {
        this.isShowSidebarOnMobile = true;
      }
      setTimeout(() => {
        this.sidebar && this.sidebar.switchToTours();
      }, 300);
    }
  }

  private forSingleTourView(tripId, singleTripId) {
    if (tripId === 'tour' && singleTripId) {
      this.urlTourID = singleTripId;
      this.isForTourList = true; // hide other irrelevant elements
      this.isForSingleTour = true;
      if (this.isMobile) {
        this.isShowSidebarOnMobile = true;
      }
      setTimeout(() => {
        this.sidebar && this.sidebar.switchToTours(singleTripId);
      }, 300);
      // return;
    }
  }

  private forPDFDownload(pdf, version, tourOrTrip, tourOrTripId) {
    if (pdf === 'pdf') {
      this.isPrintVersion = version === 'print';
      this.isForExportPDF = true;
      this.loadingTip = 'Loading PDF...';

      if (tourOrTrip === 'tour') {
        this.urlTourID = tourOrTripId;
        setTimeout(() => {
          this.sidebar.switchToTours(tourOrTripId);
        }, 600);
      } else {
        setTimeout(() => {
          this.visitorApiService.getTripTemp(this.hubName, tourOrTripId).subscribe((trip) => {
            console.log(trip);
            let items = JSON.parse(trip.trips);
            if (!isNullOrUndefined(items.length)) {
              // all trips
              this.sidebar.printTourOrTrip(items, this.isPrintVersion);
            } else {
              // single trip
              this.sidebar.printTourOrTrip([items], this.isPrintVersion);
            }
          });
          // return;
        }, 600);
      }

      if (this.isMobile) {
        this.isShowSidebarOnMobile = true;
      }
      this.pageSpinner.show();
      // return;
    }
  }

  private processSettings(allSettings, regionId) {
    if (allSettings.toggles) {
      this.featuresToggle = allSettings.toggles;
    }
    this.allFrontendSettings.toggle = this.featuresToggle;
    this.allFrontendSettings.regions = allSettings.regions;
    this.allFrontendSettings.customSettings = new VisitorSettingsCommand();
    this.allFrontendSettings.customSettings.placeImagesShownCount = allSettings.placeImagesShownCount;
    this.allFrontendSettings.customSettings.tripPlannerDetailsStyle = allSettings.tpDetailsStyle;
    this.allFrontendSettings.dataSource = allSettings.dataSource;
    this.allFrontendSettings.style = allSettings.style;
    this.allFrontendSettings.customSettings.customDefaultPlaceCategory = allSettings.customDefaultPlaceCategory;
    if (allSettings.multiCityBlock) {
      this.isMultiCityBlock = isNullOrUndefined(allSettings.multiCityBlock.active)
        ? true
        : allSettings.multiCityBlock.active;
    }
    if (allSettings.regions && allSettings.toggles.multipleCities) {
      this.setMultipleCities(allSettings, regionId);
    }
    if (!this.featuresToggle.multipleCities) {
      this.tpHomeImageUrl =
        isNullOrUndefined(allSettings.tpHomeImage) ||
        isNullOrUndefined(allSettings.tpHomeImage.isDefault) ||
        allSettings.tpHomeImage.isDefault
          ? null
          : allSettings.tpHomeImage.url;
      if (this.tpHomeImageUrl) {
        this.tpHomeImageUrl = this.imageService.imageSourceUrl(this.tpHomeImageUrl);
      }
    }
    // let tourSidebarImage = (isNullOrUndefined(allSettings.tourSidebarImage) || isNullOrUndefined(allSettings.tourSidebarImage.isDefault) || allSettings.tourSidebarImage.isDefault) ? null : allSettings.tourSidebarImage.url;
    // this.allFrontendSettings.customSettings.tourSidebarImage = { isDefault: allSettings.tourSidebarImage.isDefault, url: tourSidebarImage};
    this.allFrontendSettings.customSettings.tourSidebarImage = allSettings.tourSidebarImage;
    let logoUrl =
      isNullOrUndefined(allSettings.logo) || isNullOrUndefined(allSettings.logo.isDefault) || allSettings.logo.isDefault
        ? config.defaultLogoUrl
        : allSettings.logo.url;
    VisitorDataCache.logo = this.imageService.imageSourceUrl(logoUrl);
    VisitorDataCache.placeCategories = allSettings.placeCategories;
    if (allSettings.style) {
      Object.keys(allSettings.style.tripPlanner).forEach((x) => {
        this.style.tripPlanner[x].color.value =
          allSettings.style.tripPlanner[x].color || this.style.tripPlanner[x].color.value;
      });
      this.allFrontendSettings.style = this.style;
    }
    this.allFrontendSettingsStore.allFrontendSettingsCommand.next(this.allFrontendSettings);

    if (!this.isForExportPDF) {
      this.pageSpinner.hide();
    }
  }

  ngAfterViewChecked() {
    this.setCustomColor();
    this.ref.detectChanges();
  }

  private setCustomColor() {
    if (!this.tripWrap) return;

    try {
      const dateIcons = this.tripWrap.nativeElement.querySelectorAll('.ig-date-field svg');
      for (let i = 0; i < dateIcons.length; i++) {
        (dateIcons[i] as HTMLElement).style.color = this.style.tripPlanner.buttons.color.value;
      }

      const startBtn = this.tripWrap.nativeElement.querySelector('.trip-start button');
      startBtn && ((startBtn as HTMLElement).style.backgroundColor = this.style.tripPlanner.buttons.color.value);

      const submitBtns = this.tripWrap.nativeElement.querySelectorAll('.submit-wrap button');
      for (let i = 0; i < submitBtns.length; i++) {
        (submitBtns[i] as HTMLElement).style.backgroundColor = this.style.tripPlanner.buttons.color.value;
      }

      const loginBtn = this.tripWrap.nativeElement.querySelector('.trip .login-with-fb ig-button button');
      loginBtn && ((loginBtn as HTMLElement).style.backgroundColor = this.style.tripPlanner.trip.color.value);

      const loginBtnMobile = this.tripWrap.nativeElement.querySelector('.trip ig-social-login-popup ig-button button');
      loginBtnMobile &&
        ((loginBtnMobile as HTMLElement).style.backgroundColor = this.style.tripPlanner.trip.color.value);

      let head = document.getElementsByTagName('head')[0];
      let s = document.createElement('style');
      s.setAttribute('type', 'text/css');
      let css = '';
      if (this.style.tripPlanner.tour.color.value) {
        css += `--tour-btn-background-color: ${this.style.tripPlanner.tour.color.value};`;
      }
      if (this.style.tripPlanner.trip.color.value) {
        css += `--trip-btn-background-color: ${this.style.tripPlanner.trip.color.value};`;
      }
      s.appendChild(
        document.createTextNode(`
                    :root {
                    ${css}
                    }
                `)
      );
      head.appendChild(s);
    } catch (e) {
      console.error('Error in setCustomColor', e);
    }
  }

  public get isUserLoggedIn() {
    return SocialLoginPopupComponent.isUserLoggedIn;
  }

  public get isEventEnabled() {
    return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
  }

  public get isShowingEventOrPlace() {
    return this.sidebar ? this.sidebar.displayingOn === 'event' || this.sidebar.displayingOn === 'place' : true;
  }

  public get mapSectionWidth() {
    let width = this.isShowingEventOrPlace
      ? this.isSmallestPC
        ? 'calc(33% - 16px)'
        : 'calc(41.6667% - 16px)'
      : 'calc(70% - 16px)';
    return this.isMobile
      ? '100%'
      : this.isShowFloatDetail
      ? this.isShowfloatDetailPlaceFeeds
        ? `calc(${width} - 660px)`
        : `calc(${width} - 330px)`
      : width;
  }

  public get placeHolderWidth() {
    return this.isShowFloatDetail ? (this.isShowfloatDetailPlaceFeeds ? '660px' : '330px') : '0';
  }

  public goToSubmitPage(where: string) {
    const path = getRouteUrl(routeConfigs.submit[where], {
      hubName: this.hubName,
    });
    console.log({ path });
    this.router.navigateByUrl(path, { skipLocationChange: this.noChangeUrlWhenRedirect });
  }

  private checkGDPR() {
    const acceptCookie = localStorage.getItem(localStorageKeys.GDPRAcceptCookie);
    if (!acceptCookie) {
      this.isShowGDPR = true;
    }
  }

  public acceptCookie() {
    localStorage.setItem(localStorageKeys.GDPRAcceptCookie, 'true');
    this.isShowGDPR = false;
  }

  // actually this process (handle the login button styles) is not necessary, as the login button component would handle it.
  // But we have to use two login button components to achieve client's design on multiple cities trip planner. So it comes up with some style issues, which are handled here
  public socialLoggedIn(status) {
    console.log({ status });
    if (!status) {
      return;
    }
    this.isLoggedIn = status.status;
    //this.searchLogginIn ? this.searchLogginIn.nativeElement.style.display = 'none' : '';
    if (this.isMobile) {
      setTimeout(() => {
        if (this.isLoggedIn) {
          this.searchNotLoggedIn ? (this.searchNotLoggedIn.nativeElement.style.display = 'none') : '';
          this.searchLogginIn ? (this.searchLogginIn.nativeElement.style.display = 'block') : '';
          this.loginIcon && (this.loginIcon.nativeElement.style.width = '10%');
          this.loginBtnLoggedIn ? (this.loginBtnLoggedIn.nativeElement.style.display = 'block') : '';
          this.loginBtnNotLoggedIn ? (this.loginBtnNotLoggedIn.nativeElement.style.display = 'none') : '';
          if (this.sidebar && this.sidebar.countBaseIcon) {
            this.sidebar.countBaseIcon.nativeElement.style.visibility = 'visible';
          }
          //this.featuresToggle.multipleCities ? this.loginTip.nativeElement.style.display = 'none' : '';
          setTimeout(() => {
            this.profileImage = status.profileImg;
            this.profile ? (this.profile.nativeElement.src = this.profileImage) : '';
            this.FBLoggedIn();
          });
        } else {
          setTimeout(() => {
            this.searchNotLoggedIn ? (this.searchNotLoggedIn.nativeElement.style.display = 'block') : '';
            this.searchLogginIn ? (this.searchLogginIn.nativeElement.style.display = 'none') : '';
            this.loginIcon && (this.loginIcon.nativeElement.style.width = '100%');
            this.loginBtnLoggedIn ? (this.loginBtnLoggedIn.nativeElement.style.display = 'none') : '';
            //(this.loginBtnLoggedIn && !this.featuresToggle.multipleCities) ? this.loginBtnLoggedIn.nativeElement.style.display = 'none' : '';
            this.loginBtnNotLoggedIn ? (this.loginBtnNotLoggedIn.nativeElement.style.display = 'block') : '';
            if (this.sidebar && this.sidebar.countBaseIcon) {
              this.sidebar.countBaseIcon.nativeElement.style.visibility = 'visible';
            }
            this.profileImage = null;
            this.FBLoggedIn();
            //this.showLoginTip();
          }, 1100);
        }
      });
    } else {
      setTimeout(() => {
        this.FBLoggedIn();
      }, 2000);
    }
  }

  public closeLoginTip() {
    this.featuresToggle.multipleCities ? (this.loginTip.nativeElement.style.display = 'none') : '';
    this.loginBtnLoggedIn ? (this.loginBtnLoggedIn.nativeElement.style.position = 'initial') : '';
    this.loginBtnWrap ? (this.loginBtnWrap.nativeElement.style.position = 'initial') : '';
  }

  public showLoginTip() {
    // let isShown = localStorage.getItem(localStorageKeys.tripPlannerLoadingTip);
    // if (isShown) {
    //     return;
    // }
    // console.log(document.cookie);
    //
    // document.cookie = "{tripPlannerLoadingTip: {isShown: true}}";
    // console.log(document.cookie);

    this.featuresToggle.multipleCities ? (this.loginTip.nativeElement.style.display = 'block') : '';
    //localStorage.setItem(localStorageKeys.tripPlannerLoadingTip, JSON.stringify({ isShown: true }));
  }

  public goBack() {
    // this.sidebar.switchToEvents();
    this.isShowSidebarOnMobile = false;

    setTimeout(() => {
      this.isShowDirectionMap = false;
      this.isShowNormalMap = false;
      this.isShowTour = false;
    });
  }

  public start() {
    if (!this.isMobile) {
      if (!this.sidebar.events || !this.sidebar.events.length) {
        this.isShowWelcomepageNoEventTip = true;
        return;
      }

      this.isShowNormalMap = true;
      this.isInfoWindowsOpen = [];
      this.sidebar.events.filter((x) => !x.isOnlineEvent);
      this.items = this.sidebar.setEventMapIcon(this.sidebar.events || []);
      for (let i = 0; i < this.items.length; i++) {
        this.isInfoWindowsOpen.push(false);
      }

      if (this.items.length > 1) {
        this.googleMapService.fitBounds(this.items).subscribe((data) => {
          this.latLngBounds = data;
        });
      }
    } else {
      if (!this.from && !this.to) {
        this.showEvents();
      } else {
        this.isShowSidebarOnMobile = true;
        this.visitorApiService
          .getEvents(this.hubName, {
            limit: config.searchLimit,
            page: 1,
            category: 'all',
            from: this.from,
            to: this.to,
          })
          .subscribe((data) => {
            VisitorDataCache.events = data;
            this.sidebar.afterGotEvents(data);
          });
      }
    }

    this.isStarted = true;
  }

  public scrollToTop() {
    this.tripWrap.nativeElement.scrollTop = 0;
  }

  public setMapCenter(lat, lng) {
    this.lat = lat;
    this.lng = lng;
  }

  public gotoDetails(item) {
    this.sidebar.showDetails(item, item.startTime ? 'event' : 'place', false);
    if (this.isMobile) {
      this.invisiblePopup();
    }
  }

  public removeFromTrip(item) {
    this.sidebar.attractionlist.removeFromList(item._id);
  }

  public showEvents() {
    if (this.isMobile) {
      this.isShowSidebarOnMobile = true;
    }
    setTimeout(() => {
      this.sidebar.switchToEvents(true);
    });
  }

  public showPlaces() {
    if (this.isMobile) {
      this.isShowSidebarOnMobile = true;
    }
    setTimeout(() => {
      this.sidebar.switchToPlaces();
    });
  }

  public showToursView() {
    if (this.isMobile) {
      this.isShowSidebarOnMobile = true;
    }
    setTimeout(() => {
      this.sidebar.switchToTours();
    });
  }

  public showTrips() {
    if (this.isMobile) {
      this.isShowSidebarOnMobile = true;
    }
    setTimeout(() => {
      this.sidebar.switchToTrip();
    });
  }

  public searchCity(searchText) {
    this.searchCityText = searchText;
    return this.visitorApiService.searchCities(this.hubName, this.searchCityText);
  }

  public searchCityResultSelect(selectedItem) {
    let inThisRegion = null;
    for (let region of this.allRegions) {
      if (region.cities.any((city) => city.id === selectedItem.id)) {
        inThisRegion = region;
        break;
      }
    }
    if (inThisRegion) {
      this.setSelectedRegion(inThisRegion.id);
      this.processRegion(inThisRegion, selectedItem.id);
    } else {
      this.loadingRegion = true;
      this.visitorApiService.getRegionByCity(this.hubName, selectedItem.id).subscribe((region) => {
        this.loadingRegion = false;
        if (region) {
          this.setSelectedRegion(region.id);
          this.processRegion(region, selectedItem.id);
        } else {
          alert('This city is not in any region');
        }
      });
    }
    this.citySearch.clearSearchText();
  }

  public clearSearchText() {
    this.searchText = '';
    this.sidebar.search(this.searchText, this.from, this.to);
  }

  public search() {
    this.sidebar.search(this.searchText, this.from, this.to);
  }

  public filterEvents() {
    if (!this.isMobile) {
      this.sidebar.filterEventsByDate(this.searchText, this.from, this.to);
      this.isShowWelcomepageNoEventTip = false;
    } else {
      // this.visitorApiService.getEvents(this.hubName,
      //     {
      //         limit: config.searchLimit,
      //         page: 1,
      //         category: 'all',
      //         search: searchText,
      //         from,
      //         to
      //     }).subscribe(data => {
      //     EventTimeService.formatEventTime(data);
      //     this.allEventsOrPlaces = data;
      //     this.setPaggination(data);
      //     this.hideMask();
      // });
    }
  }

  public invisiblePopup() {
    // if (this.popup) {
    //     this.popup.nativeElement.style.top = this.popup.nativeElement.style.height;
    // }
  }

  public visiblePopup() {
    if (this.popup && (this.isShowNormalMap || this.isShowDirectionMap)) {
      this.popup.nativeElement.style.top = '0px';
    }
  }

  public showPopup() {
    setTimeout(() => {
      this.popup.nativeElement.style.top = '0px';
    });
  }

  public hidePopup() {
    this.popup.nativeElement.style.top = this.popup.nativeElement.style.height;
    if (this.direction && !isNullOrUndefined(this.direction.currentIndex)) {
      this.direction.currentIndex = null;
    }
    this.isShowNormalMap = false;
    this.isShowDirectionMap = false;
  }

  public searchItemInTourOrTrip(searchText) {
    if (!searchText) {
      return;
    }
    let items = [];
    let targets = [];
    if (this.sidebar.displayingOn === 'tour') {
      if (this.sidebar.currentTour) {
        targets = this.sidebar.currentTour.attractions;
      }
    } else if (this.sidebar.displayingOn === 'trip') {
      if (this.sidebar.trips) {
        targets = this.sidebar.trips.attractions;
      }
    }
    for (let item of targets) {
      if (
        item.item.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
        //|| (item.description&&item.description.toLowerCase().indexOf(searchText.toLowerCase()) !== -1)
      ) {
        items.push(item.item);
      }
    }

    return Observable.create((observable) => {
      observable.next(items);
      observable.complete();
    });
  }

  public searchResultSelectedInTourOrTrip(selectedItem) {
    let index = 0;
    let targets = [];
    if (this.sidebar.displayingOn === 'tour') {
      if (this.sidebar.currentTour) {
        targets = this.sidebar.currentTour.attractions;
      }
    } else if (this.sidebar.displayingOn === 'trip') {
      if (this.sidebar.trips) {
        targets = this.sidebar.trips.attractions;
      }
    }
    for (let item of targets) {
      if (item.item._id === selectedItem._id) {
        break;
      }
      index++;
    }
    this.direction.showInfoWindowByIndex(index);
  }

  public floatDetailPlaceFeedsRetrieved($event) {
    if (!this.isShowfloatDetailPlaceFeeds) {
      this.isShowfloatDetailPlaceFeeds = true;
    }
    if ($event) {
      setTimeout(() => {
        this.setMapCenter($event.item.address.lat || $event.item.lat, $event.item.address.lng || $event.item.lng);
      }, 500);
    }
  }

  public showOnMap($event) {
    // if (this.isMobile) {
    //     this.googleMapService.getGoogle().then(() => {
    //         this.isShowSelectedMarker = true;
    //     });
    // }

    this.isInfoWindowsOpen = [];
    $event.items = $event.items.filter((x) => !x.isOnlineEvent);
    this.items = $event.items;
    for (let i = 0; i < this.items.length; i++) {
      this.isInfoWindowsOpen.push(false);
    }

    if (this.items.length > 1) {
      this.googleMapService.fitBounds(this.items).subscribe((data) => {
        this.latLngBounds = data;
      });
    }
    setTimeout(() => {
      this.isShowNormalMap = true;
      this.isShowTour = false;
      this.isShowDirectionMap = false;
      if (this.isMobile) {
        this.googleMapService.getGoogle().then(() => {
          this.mapBottomInfoItem = this.items[$event.index];
          this.mapBottomInfoIndex = -1;
          this.showPopup();
          setTimeout(() => {
            this.mapBottomInfo.show();
          });
        });
      } else {
        if (!isNullOrUndefined($event.index)) {
          this.isInfoWindowsOpen[$event.index] = true;
        }
      }
    });
  }

  public normalMapReady() {
    setTimeout(() => {
      this.isNormalMapReady = true;
    });
  }

  public startPlan() {
    this.isPlanStarted = true;
    if (this.mapBottomInfo) {
      this.mapBottomInfo.close();
    }
  }

  public mapMarkerClick(item) {
    if (this.isMobile) {
      this.mapBottomInfoItem = item;
      this.mapBottomInfoIndex = -1;
      this.mapBottomInfo.show();
    }
  }

  public showInfoWindowByIndex(index: number) {
    if (!this.isMobile) {
      this.hideAllSingleInfoWindow();

      setTimeout(() => {
        this.isInfoWindowsOpen[index] = true;
      });
    }
  }

  public drawDirectionRoute(tour?) {
    this.tripTour = new HubTour();
    if (tour) {
      tour.attractions.forEach((x, index) => {
        x.order = index;
      });
      this.tripTour = tour;
      this.tripTour.isEventImageProcessed = true;
    } else {
      let userID = null;
      if (SocialLoginPopupComponent.isUserLoggedIn) {
        userID = SocialLoginPopupComponent.userId;
      }
      let isShared = false;
      if (this.urlTripID) {
        userID = this.urlTripFromUserID;
        isShared = true;
      }
      let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID, isShared);
      let trip = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
      if (!trip) {
        trip = new TripStorageCommand();
        trip.trips = [];
      } else {
        trip.trips = trip.trips.removeDuplicate();
        trip.trips.forEach((x) => {
          x.attractions = x.attractions.removeDuplicate();
        });
      }

      // this.tripTour.attractions = [];
      // trip.attractions.forEach((x, index) => {
      //     let item = new Attraction();
      //     item.item = x.item;
      //     item.order = index;
      //     this.tripTour.attractions.push(item);
      // });
    }
  }

  public showDirectionMap(tour?) {
    this.drawDirectionRoute(tour);

    if (this.isShowDirectionMap) {
      setTimeout(() => {
        this.direction.drawFullRoute();
        if (this.isMobile) {
          this.showPopup();
        }
      });
    } else {
      this.isShowDirectionMap = true;

      if (this.isMobile) {
        this.showPopup();
      }
    }
    this.isShowNormalMap = false;
  }

  public hideMap() {
    this.isShowDirectionMap = false;
    this.mobilesearch.clearSearchText();
  }

  public mapReady() {
    if (this.direction) {
      this.direction.ready();
    }
  }

  public reorder($event) {
    this.showDirectionMap($event);
  }

  public afterRemoveFromTrip(trip?) {
    if (!this.isMobile) {
      if (this.sidebar.displayingOn === 'trip') {
        this.showDirectionMap(trip);
      }
    } else {
      if (this.isShowDirectionMap) {
        this.drawDirectionRoute(trip);
        setTimeout(() => {
          this.direction.drawFullRoute();
        });
        this.direction.currentIndex = null;
      }
    }
  }

  public showTours(tours) {
    this.tours = tours;
    this.isShowDirectionMap = false;
    this.isShowTour = true;

    if (!this.isMobile) {
      setTimeout(() => {
        if (tours && tours.length) {
          this.isNoContent = false;
          this.waterFallContainer.startLoading();
          this.waterFallContainer.reLayout();
        } else {
          this.isNoContent = true;
        }
      }, 200);
    }
  }

  public selectRegion(target) {
    console.log(target);
    this.noCities = false;
    this.isMultiCityBlock && this.blockNavigator.scrollToStart();

    if (target.value === 'all') {
      if (this.allRegionsInOne.cities && this.allRegionsInOne.cities.length) {
        this.allRegionsInOne.cities = this.allRegionsInOne.cities.sortBy((x) => x.cityTitle);
        this.currentRegion = this.allRegionsInOne;
        if (this.isMultiCityBlock) {
          this.blockNavigator.setSelectedCity(this.allRegionsInOne.cities[0]);
          this.blockNavigator.getIsNeedScroll();
          this.gotoCity({ id: this.allRegionsInOne.cities[0].id });
        }
      } else {
        this.noCities = true;
      }
      return;
    }

    if (this.allRegions) {
      let region = this.allRegions.first((x) => x.id === target.value);
      if (region && region.cities.length) {
        this.processRegion(region);
      } else {
        this.loadingRegion = true;
        this.visitorApiService.getRegion(this.hubName, region.id).subscribe((data) => {
          this.loadingRegion = false;
          region = data;
          let index = this.allRegions.getElementIndex((x) => x.id === target.value);
          this.allRegions[index] = region;
          this.processRegion(region);
        });
      }
    }
  }

  public gotoCity($event, isGotoTours = false) {
    console.log($event);
    //this.pageSpinner.show();
    this.sidebar.showMask();
    let feedId = $event.id;

    this.sidebar.resetPlaceCategoty();
    this.sidebar.switchToPlaces(false, feedId, isGotoTours);
    //this.sidebar.hideMask();

    // this.visitorApiService.getPlaces(this.hubName, {
    //     feedId,
    //     category: 'all'
    // }).subscribe(data => {
    //     console.log(`place count: ${data.length}`);
    //     VisitorDataCache.places = data;
    //     setTimeout(() => {
    //         this.sidebar.switchToPlaces(false, feedId);
    //         this.sidebar.hideMask();
    //     }, 500);
    // });
  }

  public setPDFLoadingTip(array: Array<number>) {
    if (this.isForExportPDF) {
      this.loadingTip = 'Loading PDF...' + array.getRandom() + '%';
    }
  }

  public showTourDetail(tour) {
    let travelTime = tour.travelTime || null;
    let distance = tour.distance || null;
    this.visitorApiService.getTourDetail(this.hubName, tour._id, true).subscribe((data) => {
      this.setPDFLoadingTip([13, 14, 15, 16]);
      let items = [];
      data.attractions.forEach((item) => {
        if (item.status !== 'not found') {
          items.push(item);
        }
      });
      data.attractions = items;
      if (this.isEventEnabled) {
        this.getEventsFromCache().subscribe((events) => {
          data.attractions = this.processDefaultImages(data);
          this.processForOpeningTour(data, travelTime, distance);
        });
      } else {
        this.processForOpeningTour(data, travelTime, distance);
      }
    });
  }

  public loadMore() {}

  private processForOpeningTour(data, travelTime, distance) {
    this.tripTour = data;
    this.tripTour.travelTime = travelTime;
    this.tripTour.distance = distance;
    this.tripTour.isEventImageProcessed = true;
    this.sidebar && this.sidebar.showTourDetail(data);
    if (!this.isMobile) {
      this.isShowDirectionMap = true;
    } else {
      this.sidebar.hideTourSpinner();
    }
    if (this.isForExportPDF) {
      this.sidebar.printTour(this.isPrintVersion);
    }
  }

  // 10214072230112487
  public FBLoggedIn() {
    //this.syncTripsWithDB('10214072230112487');

    if (!this.urlTripID) {
      if (SocialLoginPopupComponent.isUserLoggedIn) {
        let userID = SocialLoginPopupComponent.userId;
        this.syncTripsWithDB(userID);
      } else {
      }
    } else {
      if (SocialLoginPopupComponent.isUserLoggedIn) {
        this.syncSharedTripsWithDB(SocialLoginPopupComponent.userId);
      }
    }
  }

  public syncTripsWithDB(userID) {
    this.getTripsFromDB(userID).subscribe((tripsInDB) => {
      console.log('tripsInDB', tripsInDB);
      let tripsInCookie = this.getUserTripInCookie(userID);
      console.log('tripsInCookie', tripsInCookie);
      if (tripsInDB && tripsInDB.updateTime) {
        if (tripsInCookie && tripsInCookie.updateTime) {
          if (tripsInDB.updateTime < tripsInCookie.updateTime) {
            tripsInCookie.userFacebookId = userID;
            tripsInCookie.id = tripsInDB.id;
            tripsInDB.trips = tripsInCookie.trips;
            this.updateTripToDB(tripsInCookie, userID);
          } else {
            tripsInDB.timestamp = new Date();
          }
        } else {
          tripsInDB.timestamp = new Date();
        }
        this.setLocalStorage(tripsInDB, userID);
        this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
      } else if (!tripsInDB) {
        if (tripsInCookie && tripsInCookie.timestamp) {
          this.createTripInDB(userID, tripsInCookie).subscribe((tripId) => {
            this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
          });
          this.setLocalStorage(tripsInCookie, userID);
        }
      }
      setTimeout(() => {
        this.sidebar && this.sidebar.getTripCount(userID);
      });
    });
  }

  public GoogleSignIn() {}

  public onSignIn(googleUser) {
    let profile = googleUser.getBasicProfile();
    console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
    console.log('Name: ' + profile.getName());
    console.log('Image URL: ' + profile.getImageUrl());
    console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
  }

  public syncTripsWithDBAsync(userID): Observable<any> {
    return Observable.create((observer) => {
      if (userID) {
        this.getTripsFromDB(userID).subscribe((tripsInDB) => {
          let tripsInCookie = this.getUserTripInCookie(userID);
          if (tripsInDB && tripsInDB.timestamp) {
            if (tripsInCookie && tripsInCookie.timestamp) {
              if (tripsInDB.timestamp < tripsInCookie.timestamp) {
                tripsInCookie.userFacebookId = userID;
                tripsInCookie.id = tripsInDB.id;
                tripsInDB.trips = tripsInCookie.trips;
                this.updateTripToDB(tripsInCookie, userID);
              } else {
                tripsInDB.timestamp = new Date();
              }
            } else {
              tripsInDB.timestamp = new Date();
            }
            this.setLocalStorage(tripsInDB, userID);
            this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
            observer.next(tripsInDB);
            observer.complete();
          } else {
            if (tripsInCookie && tripsInCookie.timestamp) {
              this.createTripInDB(userID, tripsInCookie).subscribe((tripId) => {
                this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
              });
              this.setLocalStorage(tripsInCookie, userID);
              observer.next(tripsInCookie);
              observer.complete();
            }
          }
          setTimeout(() => {
            this.sidebar.getTripCount(userID);
          });
        });
      } else {
        observer.next(null);
        observer.complete();
      }
    });
  }

  private syncSharedTripsWithDB(userID) {
    if (userID === this.urlTripFromUserID) {
      this.getTripsFromDB(userID).subscribe((tripsInDB) => {
        let tripsInCookie = this.getSharedUserTripInCookie();
        if (tripsInDB && tripsInDB.timestamp) {
          if (tripsInCookie && tripsInCookie.timestamp) {
            if (tripsInDB.timestamp < tripsInCookie.timestamp) {
              tripsInCookie.userFacebookId = userID;
              tripsInCookie.id = tripsInDB.id;
              tripsInDB.attractions = tripsInCookie.attractions;
              this.updateTripToDB(tripsInCookie, userID);
            } else {
              tripsInDB.timestamp = new Date();
            }
          } else {
            tripsInDB.timestamp = new Date();
          }
          this.setLocalStorage(tripsInDB, userID);
          this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripsInDB.id));
        } else {
          if (tripsInCookie && tripsInCookie.timestamp) {
            this.createTripInDB(userID, tripsInCookie).subscribe((tripId) => {
              this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripId));
            });
            this.setLocalStorage(tripsInCookie, userID);
          }
        }
        setTimeout(() => {
          this.sidebar.getTripCount(userID);
        });
      });
    } else {
      // this.getTripsFromDB(this.urlTripFromUserID).subscribe(tripsInDB => {
      //     let tripsInCookie = this.getSharedUserTripInCookie();
      //     if (tripsInDB) {
      //         tripsInCookie.userFacebookId = this.urlTripFromUserID;
      //         tripsInCookie.id = tripsInDB.id;
      //         tripsInDB.attractions = tripsInCookie.attractions;
      //         this.updateTripToDB(tripsInCookie, userID);
      //         this.setLocalStorageForSharedTrip(tripsInDB, this.urlTripFromUserID);
      //     } else {
      //         this.createTripInDB(userID, tripsInCookie).subscribe(tripId => {
      //             this.visitorTripIdStore.tripIdCommand.next(new VisitorTripIdCommand(tripId));
      //         });
      //         this.setLocalStorageForSharedTrip(tripsInCookie, this.urlTripFromUserID);
      //     }
      // });
    }
  }

  private setSelectedRegion(id) {
    this.regionSource.forEach((x) => (x.selected = false));
    this.regionSelect.setSelected(id);
  }

  private processRegion(region, gotoThisCity?) {
    region.cities = region.cities.sortBy((x) => x.cityTitle);
    this.currentRegion = region;
    if (region.cities && region.cities.length) {
      setTimeout(() => {
        if (gotoThisCity) {
          this.blockNavigator.setSelectedCityById(gotoThisCity);
          this.blockNavigator.scrollToCity(gotoThisCity);
        } else {
          this.isMultiCityBlock && this.blockNavigator.setSelectedCity(region.cities[0]);
        }
        if (this.isMultiCityBlock) {
          this.blockNavigator.getIsNeedScroll();
          this.gotoCity({ id: gotoThisCity || region.cities[0].id });
        } else {
          this.sidebar.resetPlaceCategoty();
          VisitorDataCache.tours = null;
          this.sidebar.switchToPlaces();
        }
      });
    } else {
      this.noCities = true;
    }
  }

  private getTripsFromDB(userID) {
    return this.visitorApiService.getUserTrips(this.hubName, userID);
  }

  private getTripsFromDBByTripID(tripID) {
    return this.visitorApiService.getUserTripByTripID(this.hubName, tripID);
  }

  private setLocalStorage(trips, userID) {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID);
    localStorage.setItem(keyWithUserID, JSON.stringify(trips));
    localStorage.setItem(key, JSON.stringify(trips));
    if (this.sidebar && this.sidebar.displayingOn === 'trip') {
      this.sidebar.switchToTrip();
    }
    //localStorage.removeItem(key);
  }

  private setLocalStorageForSharedTrip(trips, fromUserID, switchToTrip?) {
    // if (FacebookLoginButtonComponent.isUserLoggedIn && fromUserID === FacebookLoginButtonComponent.authResponse.authResponse.userID) {
    if (SocialLoginPopupComponent.isUserLoggedIn && fromUserID === SocialLoginPopupComponent.userId) {
      this.setLocalStorage(trips, fromUserID);
      if (switchToTrip) {
        if (this.isMobile) {
          this.isShowSidebarOnMobile = true;
        }
        setTimeout(() => {
          this.sidebar.switchToTrip(true);
        });
      }
    } else {
      let keyWithUserIDShared = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, fromUserID, true);
      localStorage.setItem(keyWithUserIDShared, JSON.stringify(trips));
      if (switchToTrip) {
        if (this.isMobile) {
          this.isShowSidebarOnMobile = true;
        }
        setTimeout(() => {
          this.sidebar.switchToTrip(true);
        });
      }
    }
  }

  private getUserTripInCookie(userID) {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID);
    let storage = localStorage.getItem(key);
    let storageWithUserID = localStorage.getItem(keyWithUserID);
    let tripsInCookie = JSON.parse(storage) as TripStorageCommand;
    let tripsInCookieWithUserID = JSON.parse(storageWithUserID) as TripStorageCommand;

    if (tripsInCookie && !tripsInCookieWithUserID) {
      return tripsInCookie;
    }
    if (!tripsInCookie && tripsInCookieWithUserID) {
      return tripsInCookieWithUserID;
    }
    if (!tripsInCookie && !tripsInCookieWithUserID) {
      return null;
    }
    if (tripsInCookie && tripsInCookieWithUserID) {
      if (!tripsInCookie.updateTime || !tripsInCookieWithUserID.updateTime) {
        return tripsInCookieWithUserID;
      }
      return tripsInCookie.updateTime < tripsInCookieWithUserID.updateTime ? tripsInCookieWithUserID : tripsInCookie;
    }
  }

  private getSharedUserTripInCookie() {
    let keyWithUserIDShared = LocalStorageService.getLocalStorageKeyForVisitorTrip(
      this.hubName,
      this.urlTripFromUserID,
      true
    );
    let storageWithUserID = localStorage.getItem(keyWithUserIDShared);
    let tripsInCookieWithUserID = JSON.parse(storageWithUserID) as CreateTripCommand;
    return tripsInCookieWithUserID;
  }

  private createTripInDB(userID, tripsInCookie): Observable<any> {
    return Observable.create((observer) => {
      let command = new CreateTripCommand();
      command.id = guid();
      command.userFacebookId = userID;
      command.hubName = this.hubName;
      command.timestamp = new Date();
      command.attractions = tripsInCookie.attractions;
      // this.visitorApiService.createTrip(this.hubName, command).subscribe(() => {
      //         observer.next(command.id);
      //         observer.complete();
      //     }
      // );
    });
  }

  private updateTripToDB(tripsInCookie, userID) {
    tripsInCookie.trips.forEach((x) => {
      if (!x.id) {
        x.id = guid();
      }
    });
    this.visitorApiService.updateTrip(this.hubName, tripsInCookie).subscribe();
  }

  private hideAllSingleInfoWindow() {
    if (this.isInfoWindowsOpen && this.isInfoWindowsOpen.length) {
      for (let i = 0; i < this.isInfoWindowsOpen.length; i++) {
        this.isInfoWindowsOpen[i] = false;
      }
    }
  }

  private processDefaultImages(data) {
    if (!data || !data.attractions) {
      return [];
    }
    let items = [];
    data.attractions.forEach((item) => {
      if (item.status.toLowerCase() === 'ok') {
        // for those events use default images, need to load image from events cache
        if (!item.item.cover) {
          let itemInCache = VisitorDataCache.events.first((x) => x._id === item.feedId);
          if (itemInCache && itemInCache.cover) {
            item.item.cover = itemInCache.cover;
          }
        }
        items.push(item);
      }
    });
    return items;
  }

  public getEventsFromCache(): Observable<any> {
    return Observable.create((observable) => {
      let events = VisitorDataCache.events;
      if (events && events.length) {
        observable.next(events);
        observable.complete();
      } else {
        this.visitorApiService
          .getEvents(this.hubName, {
            limit: config.searchLimit,
            page: 1,
            category: 'all',
          })
          .subscribe((data) => {
            VisitorDataCache.events = data;
            observable.next(data);
            observable.complete();
          });
      }
    });
  }

  private setMultipleCities(command, regionId) {
    // this.regionSource = [{
    //     text: 'Select a Region',
    //     value: 'all',
    //     selected: !regionId
    // }];
    this.regionSource = [];
    command.regions.forEach((x, index) => {
      if (!this.regionSource.any((y) => y.value === x.id)) {
        this.regionSource.push({
          text: x.name,
          value: x.id,
          selected: x.id === regionId || (!regionId && index === 0),
        });
      }
    });

    this.allRegions = clone(command.regions);
    this.allRegionsInOne.cities = [];

    if (!regionId) {
      command.regions.forEach((x) => {
        x.cities.forEach((e) => {
          if (!this.allRegionsInOne.cities.any((y) => y.id === e.id)) {
            this.allRegionsInOne.cities.push(e);
          }
        });
      });
      this.allRegionsInOne.cities = this.allRegionsInOne.cities.sortBy((x) => x.cityTitle);
      this.currentRegion = this.allRegionsInOne;
    } else {
      let regionFromUrl = command.regions.first((x) => x.id === regionId);
      if (regionFromUrl) {
        regionFromUrl.cities = regionFromUrl.cities.sortBy((x) => x.cityTitle);
        this.currentRegion = regionFromUrl;
      } else {
        this.modalService.showErrorModal('Region id is wrong!');
        return;
      }
    }

    if (this.isMobile) {
      this.isShowSidebarOnMobile = true;
    }
    if (this.isMultiCityBlock) {
      if (this.currentRegion.cities && this.currentRegion.cities.length) {
        setTimeout(() => {
          this.blockNavigator.setSelectedCity(this.currentRegion.cities[0]);
          if (!this.urlTripID && !this.isForExportPDF) {
            this.gotoCity({ id: this.currentRegion.cities[0].id }, false);
          }
        });
      } else {
        this.noCities = true;
      }
    } else {
      setTimeout(() => {
        this.sidebar.switchToTours();
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/visitor.trip.component.ts